import { endOfDay, getTime } from 'date-fns';

export const getEndOfDayInMillis = (date: Date): number =>
  getTime(endOfDay(date));
